export default __webpack_public_path__ + "static/media/sad.c13fb457.png";